import { Facebook, Link2, MessageCircle, MessageSquare, Share2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useLanguage } from "../context/LanguageContext";
import { adShareUrl } from "../lib/api";

const enc = encodeURIComponent;
const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2H21.5l-7.5 8.57L22.8 22h-6.9l-5.4-7.06L4.3 22H1l8.03-9.18L.6 2h7.07l4.88 6.45L18.244 2zm-1.21 18h1.9L6.98 3.9H4.94L17.03 20z" /></svg>
);

export const ShareAdButton = ({ listing, className = "", size = 19, testid = "detail-share" }) => {
  const { t, lang } = useLanguage();
  const [copied, setCopied] = useState(false);
  const url = adShareUrl(listing, lang);
  const text = listing.title;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true); setTimeout(() => setCopied(false), 2000);
      toast.success(t("fsh_copied"));
    } catch { toast.error(t("fsh_failed")); }
  };
  const native = () => navigator.share({ title: listing.title, url }).catch(() => {});
  const items = [
    { id: "facebook", label: "Facebook", icon: <Facebook size={15} className="text-[#1877F2]" />, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { id: "whatsapp", label: "WhatsApp", icon: <MessageCircle size={15} className="text-[#25D366]" />, href: `https://wa.me/?text=${enc(`${text} ${url}`)}` },
    { id: "x", label: "X", icon: <XIcon />, href: `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(text)}` },
    { id: "sms", label: t("fsh_sms"), icon: <MessageSquare size={15} className="text-[#12234A]" />, href: `sms:?&body=${enc(`${text} ${url}`)}`, self: true },
  ];
  const row = "flex items-center gap-2.5 w-full px-3 h-10 rounded-lg text-sm font-medium text-[#12234A] hover:bg-slate-50 transition-colors";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`${testid}-btn`} aria-label={t("sad_title")} title={t("sad_title")}
          className={className || "h-11 w-11 rounded-full border border-slate-200 flex items-center justify-center hover:border-[#F5551E] transition-colors shrink-0"}>
          <Link2 size={size} className="text-slate-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-1.5 bg-white rounded-xl" data-testid={`${testid}-menu`} onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={copy} className={`${row} font-semibold`} data-testid={`${testid}-copy`}>
          {copied ? <Check size={15} className="text-emerald-600" /> : <Link2 size={15} className="text-[#F5551E]" />} {t("fsh_copy")}
        </button>
        {typeof navigator !== "undefined" && navigator.share && (
          <button type="button" onClick={native} className={row} data-testid={`${testid}-native`}><Share2 size={15} className="text-[#F5551E]" /> {t("fsh_native")}…</button>
        )}
        <div className="h-px bg-slate-100 my-1" />
        {items.map((i) => (
          <a key={i.id} href={i.href} target={i.self ? undefined : "_blank"} rel="noopener noreferrer" className={row} data-testid={`${testid}-${i.id}`}>
            {i.icon} {i.label}
          </a>
        ))}
      </PopoverContent>
    </Popover>
  );
};
